import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function LandingPage() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Animation happens only once
    });
  }, []);
  return (
    <div>
      <section id="hero" className="hero section">
        <div className="container text-center">
          <div className="container my-5">
            <div className="row align-items-center">
              {/* Left Side: Text */}
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                <h1 className="mb-3 text-left">
                  Pre-IPO Investment: Your Gateway to Secure and Profitable
                  Growth
                </h1>
                <p className="text-left">
                  Access exclusive pre-IPO investments with institutional-grade
                  due diligence and professional portfolio management.
                </p>
                <div class="row" style={{ marginBottom: "10px" }}>
                  <div class="col-6 col-md-6">
                    {/* <button className="btn btn-secondary w-100">
                      Opportunities
                    </button> */}
                  </div>
                  <div class="col-6 col-md-3">
                    <a href="/whatispreipo" class="btn btn-primary w-100">
                      Learn More
                    </a>
                  </div>
                </div>
              </div>

              {/* Right Side: Image */}
              <div
                className="col-md-6 text-center"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <img
                  src="assets/img/investment.png"
                  alt="Investment"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section id="about" className="about section"> */}
      <div className="bg-image">
        <div className="overlay">
          <div>
            <div className="container">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h1>What Are Pre-IPO Investments ?</h1>
                  <h4>
                    <p>
                      Pre-IPO (Initial Public Offering) investments are a unique
                      opportunity to invest in high-growth companies before
                      their shares become publicly traded. These investments
                      provide access to companies in their growth phase,
                      allowing investors to unlock significant value at
                      discounted valuations, long before the general public.
                    </p>

                    <p>
                      {" "}
                      At SYM VENTURES LLP we aim to make these exclusive
                      opportunities accessible to individuals and businesses
                      seeking secure and result-oriented investments.
                    </p>
                    <p>
                      These selected investments are backed by study, research
                      and evaluation by experienced analysts.
                    </p>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container my-5">
        <div className="row align-items-left">
          <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
            <h3 className="landingH">
              Building Awareness and Trust is our aim
            </h3>
            <p>
              Despite the immense potential of Pre-IPO investments, many
              investors are unaware of their benefits. Often, high-net-worth
              individuals (HNIs) acquire many of these opportunities, book their
              profits, and exit. This leaves other investors out of the loop,
              primarily due to a lack of knowledge or awareness about these
              lucrative options.
            </p>

            <h5 className="landingH">
              {" "}
              <i class="bi bi-check-square-fill"></i>&nbsp;Rebuilding Trust
            </h5>
            <p>
              Through honest guidance, clear processes and full disclosure, we
              strive   to rebuild confidence in the investment process.
            </p>
            <h5 className="landingH">
              <i class="bi bi-bar-chart-fill"></i>&nbsp;Promoting Awareness
            </h5>
            <p>
              Our mission is to educate investors about Pre-IPO investments  
              and their potential, ensuring everyone has a fair chance to
              benefit from these   opportunities.
            </p>
          </div>
          <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div className="row gy-4">
              <div className="col-lg-6">
                <img src="../assets/img/coi.png" className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6">
                <div className="row gy-4">
                  <div className="col-lg-12">
                    <img
                      src="../assets/img/gst.png"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-12">
                    <img
                      src="../assets/img/sbf.png"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="hero" className="hero2 section">
        <div className="container my-5">
          <div className="row">
            <div
              className="col-md-12 text-center"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <h1 className="hero2H">
                Ready to Start Your Pre-IPO Investment Journey?
              </h1>
              <h5 className="hero2H">
                Schedule a consultation with our investment experts to explore
                opportunities that align with your goals.{" "}
              </h5>
              {/* <div className="row">                
                <div className="d-none d-md-block col-md-3"></div>
                <div className="col-6 col-md-3">
                  <button
                    className="btn btn-secondary w-100"
                    style={{ backgroundColor: "#fff", color: "#0d6efd" }}
                  >
                    Schedule Consultation
                  </button>
                </div>
                <div className="col-6 col-md-3">
                  <button className="btn btn-primary w-100">
                    Download Investment Brief
                  </button>
                </div>
                <div className="d-none d-md-block col-md-3"></div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LandingPage;
